import React from 'react';
import '../styles/App.css';
import AdvancedOptions from "../components/video/options-advanced";
import Options from "../components/video/options";

let tr = require( '../utils/translations' ).translate;
let imageWorker = require("../utils/worker-image.js");
let encoderWorker = require("../utils/worker-encode-jpeg.js");


// STATIC FUNCTIONS
// =================================================================================================
// PRETTY PRINT TIME AS HH:MM:SS
// -------------------------------------------------------------------------------------------------
function formatTime( time ) {

	if ( !time ) return false;

	let hrs = ~~(time / 3600);
	let mins = ~~((time % 3600) / 60);
	let secs = ( time % 60 ).toFixed();

	let ret = "";

	if ( hrs > 0 ) {
		ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
	}

	ret += "" + mins + ":" + (secs < 10 ? "0" : "");
	ret += "" + secs;
	return ret;
}


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class VideoComponent extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {
			interval: 1000 / 9,
		};

		window.mixpanel.track( 'Pageview', {
			app: 'video-to-gif',
			action: 'video-edit',
			lang: window.userLanguage || 'CN'
		});

		this.receivedMessageCount = 0;
	};


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {
		let App = this.props.App,
			AppState = App.state,
			state = this.state,
			size = 0,
			isValid;

		if ( AppState.canvasWidth > 0 && AppState.canvasHeight > 0 ) isValid = true;


		// GET ESTIMATION OF GIF FILE SIZE
		// -----------------------------------------------------------------------------------------
		if ( !AppState.saveFrames && AppState.images && AppState.images.length ) {
			AppState.images.forEach( function ( img ) {

				let head = 'data:image/gif;base64,';
				size += Math.round( (img.length - head.length) * 3 / 4 );
			});

			size = ( size / 1024 / 1024 / 2 ).toFixed( 2 );

		} else size = false;


		// -----------------------------------------------------------------------------------------
		return (
			<div id="videoPanel">


				{/*SPINNER IF APP IS STILL SAVING FRAMES*/}
				{/*------------------------------------------------------------------------------*/}
				{AppState.showSpinner && <div className="dimmed">

					{/*BUTTON AND PROGRESS BAR FOR GENERATING GIF FUNCTION*/}
					<div className="btn-group">
						<div className="progress-container">

							<article>
								<h3>{AppState.loadingMessage}</h3>
							</article>

							<div className="progress-bar">
								<div id="progress"/>
							</div>
						</div>
					</div>
				</div>}

				<div className="Editor"
					 data-state={AppState.showSpinner ? 'remove' : undefined}>


					{/*MAIN VIDEO CONTAINER*/}
					{/*--------------------------------------------------------------------------*/}
					<div className="video">
						<div className="video-container">
							<canvas id="main-canvas"/>
						</div>


						{/*VIDEO META INFORMATION AND BUTTONS*/}
						{/*----------------------------------------------------------------------*/}
						<div className="video-meta">

							{/*FILE SIZES*/}
							<article>
								<p>{tr( 'Gif Quality', '选择GIF质量' )}</p>

								{/*QUALAITY SELECTOR*/}
								<div className="btn-group">
									<button
										className={ AppState.imageQuality === 'low' ? 'btn btn-tab-active' : 'btn' }
										data-level="low"
										onClick={ ( e ) => this.selectQuality( e )}>{tr( 'Low', '低' ) }
									</button>

									<button
										className={ AppState.imageQuality === 'medium' ? 'btn btn-tab-active' : 'btn' }
										data-level="medium"
										onClick={ ( e ) => this.selectQuality( e )}>{tr( 'Med', '中' ) }
									</button>

									<button
										className={ AppState.imageQuality === 'high' ? 'btn btn-tab-active' : 'btn' }
										data-level="high"
										onClick={ ( e ) => this.selectQuality( e )}>{tr( 'High', '高' ) }
									</button>

									{/*<button*/}
										{/*className={ AppState.imageQuality === 'advanced' ? 'btn btn-tab-active' : 'btn' }*/}
										{/*data-level="advanced"*/}
										{/*onClick={ ( e ) => this.selectQuality( e ) }>{tr( 'Adv.', '' )} /!* TODO: NEEDS TRANSLATION *!/*/}
									{/*</button>*/}
								</div>

								{/* OPTIONS BLOCK */}
								{/*{ AppState.imageQuality === 'advanced' ? <AdvancedOptions App={App} VideoScene={this}/> : <Options App={App} VideoScene={this}/> }*/}
								<Options App={App} VideoScene={this}/>

								<div className="btn-group">
									<button className={ isValid ? 'btn btn-gold' : 'btn btn-disabled' }
											onClick={ ( e ) => App.generateGif( e ) }>{tr( 'Generate Gif', '准备好了，发射！' )}
									</button>
								</div>
							</article>
						</div>


						{/*VIDEO STREAM*/}
						{/*----------------------------------------------------------------------*/}
						<div id="stream">
							<div className={"timer" + ( state.hideTimer ? ' timer-hidden' : '' )}/>

							{/*RANGE SELECT HANDLES*/}
							<div className="handle-container"
								 style={{
									 maxWidth: ( this.state.maxHandleWidth || 0 ) + 35,
									 width: ( AppState.handleWidth || 0 ) + 35,
									 left: AppState.handlePos || -15
								 }}>

								<div className="handle handle-left"
									 data-side="left"
									 onMouseDown={( e ) => this.handleDragged( e )}
									 onTouchStart={( e ) => this.handleDragged( e )}>

									<div className={'handle-time' + ( state.rightTime ? ' active' : '' )}>{formatTime( state.rightTime )}</div>
								</div>

								<div className="handle-mid"
									 data-side="middle"
									 onMouseDown={( e ) => this.handleDragged( e )}
									 onTouchStart={( e ) => this.handleDragged( e )}>

									<div
										className="handle-time active handle-time-mid">{( state.tooltip >= 10 ? tr( 'Max secs', '最大长度' ) : state.tooltip + tr( ' secs', '秒' ) )}</div>
								</div>

								<div className="handle handle-right"
									 data-side="right"
									 onMouseDown={( e ) => this.handleDragged( e )}
									 onTouchStart={( e ) => this.handleDragged( e )}>

									<div className={'handle-time' + ( state.leftTime ? ' active' : '' )}>{formatTime( state.leftTime )}</div>
								</div>
							</div>

							<div id="stream-preview"/>
						</div>
					</div>
				</div>
			</div>
		);
	}


	// USED TO SET EXTERNAL DATA AND RE RENDERING ON STATE CHANGE
	// =============================================================================================
	componentDidMount() {
		let $this = this,
			imageNeedsOrientation = ( navigator.userAgent.indexOf("Firefox") > -1 || window.checkMobile() )
				&& this.props.App.state.fileType.indexOf( 'quicktime' ) > -1;


		// WORKERS SETUP
		// -----------------------------------------------------------------------------------------
		// TAKES A JPEG FORMATTED IMAGE DATA AND CONVERS IT INTO BASE 64
		this.imageWorker = new Worker( imageWorker );
		this.imageWorker.onmessage = ( e ) => {

			$this.receivedMessageCount += 1;

			$this.props.App.state.images.push( e.data.image );
		};

		// ENCODES RAW RGB IMAGE DATA INTO JPEG FORMAT
		this.encoderWorker = new Worker( encoderWorker );
		this.encoderWorker.onmessage = ( e ) => {

			$this.imageWorker.postMessage({
				blob: e.data.data,
			});
		};


		// CREATE OFF SCREEN VIDEO ELEMENT TO DRAW FROM
		// -----------------------------------------------------------------------------------------
		this.video = document.createElement( 'video' );

		this.video.setAttribute( 'id', 'video' );
		this.video.autoplay = true;
		this.video.loop = true;
		this.video.muted = true;
		this.video.playsInline = true;

		this.video.addEventListener( 'durationchange', this.durationChange.bind( this ) );
		this.video.addEventListener( 'loadeddata', this.drawCanvas.bind( this ) );

		this.video.src = this.props.App.state.videoSource;

		if ( this.video.videoWidth > 400 ) this.video.width = 400;

		else this.video.width = this.video.videoWidth;

		if ( !( this.video.currentTime > 0 && !this.video.ended && !this.video.paused ) ) this.video.play();


		// SETUP ELEMENTS TO GET PREVIEW IMAGES
		// -----------------------------------------------------------------------------------------
		this.previewImages = [];

		this.previewCanvas = document.createElement( 'canvas' );
		this.previewCanvasContext = this.previewCanvas.getContext( '2d', { alpha: false }  );


		// SET UP PREVIEW VIDOE
		// -----------------------------------------------------------------------------------------
		this.previewVideo = document.createElement( 'video' );

		this.previewVideo.setAttribute( 'id', 'previewVideo' );
		this.previewVideo.autoplay = true;
		this.previewVideo.muted = true;
		this.previewVideo.playsInline = true;
		this.previewVideo.playbackRate = 5;

		this.previewVideo.style.maxHeight = 60 + 'px';
		this.previewVideo.style.minHeight = 0 + 'px';
		this.previewVideo.style.width = 'auto';

		this.previewVideo.addEventListener( 'loadeddata', this.previewLoaded.bind( this, {
			canvas: this.previewCanvas,
			context: this.previewCanvasContext,
			video: this.previewVideo,
			canvasWidth: this.previewVideo.offsetWidth,
			canvasHeight: this.previewVideo.offsetHeight
		}) );

		this.previewVideo.src = this.props.App.state.videoSource;


		// CREATE OFF SCREEN CANVAS
		// -----------------------------------------------------------------------------------------
		let canvas = document.getElementById( 'main-canvas' ),
			context = canvas.getContext( '2d', { alpha: false } ); // NO ALPHA TO IMPROVE PERFORMANCE


		// SET STATE AFTER COMPONET HAS MOUNTED
		// -----------------------------------------------------------------------------------------
		this.setState( prevState => ({
			imageNeedsOrientation: imageNeedsOrientation,
			canvas: canvas,
			context: context
		}) );

		this.selectQuality();
	}


	// =============================================================================================
	componentWillUnmount() {
		let handle = document.getElementsByClassName( 'handle-mid' )[ 0 ],
			handleContainerPos = handle && handle.parentNode.offsetLeft + 15,
			handleWidth = handle.offsetWidth;

		// NEED TO NULL VIDEO ON UNMOUNT TO PREVENT IMAGE ARRAY BEING POLLUTED WITH OLD IMAGES
		this.props.App.setState( prevState => ({
			videoCurrentTime: this.video.currentTime,
			handlePos: handleContainerPos,
			handleWidth: handleWidth
		}), () => {
			this.video = null;
		});
	}


	// FIRED WHENEVER A NEW VIDEO IS LOADED, SORT OF LIKE VIDEO INITIALIZED
	// =============================================================================================
	durationChange() {
		let video = this.video;

		// VIDEO IS LOADED
		if ( video.readyState ) {
			let $this = this,
				App = this.props.App,
				AppState = App.state,
				stream = document.getElementById( 'stream' ),
				handleWidth = stream.getBoundingClientRect().width / video.duration * 10,
				setTimer = true;

			// PREVENT HANDLE EVER BEING LARGER THAN THE STREAM
			if ( handleWidth >= stream.getBoundingClientRect().width ) handleWidth = stream.getBoundingClientRect().width - 30;


			// SCALE CANVAS AND RETURNED GIF DOWN TO MORE REALISTIC SIZE
			// -------------------------------------------------------------------------------------
			this.selectQuality();

			// SET CANVAS DIMENSIONS AND FINAL GIF WIDTH AND HEIGHT
			this.setDimensions( AppState.canvasWidth || video.videoWidth, AppState.canvasHeight || video.videoHeight );

			// SET STATE FOR VIDEO ELEMENT
			this.setState( prevState => ({
				tooltip: AppState.tooltipInSeconds || 0,
				maxHandleWidth: this.state.maxHandleWidth || handleWidth,
			}) );

			App.setState( prevState => ({
				videoStartTime: AppState.videoCurrentTime || video.currentTime,
				videoEndTime: AppState.videoEndTime || $this.getPositionInTime( handleWidth + 30 ),
				handleWidth: AppState.handleWidth || handleWidth,
			}) );


			// UPDATE THE CURRENT TIME AND SET THE TIME INDICATOR
			// -------------------------------------------------------------------------------------
			let updateCurrentTime = function () {

				let stream = document.getElementById( 'stream' );

				if ( !video || !stream ) return false;

				let handleMid = document.getElementsByClassName( 'handle-mid' )[ 0 ].getBoundingClientRect(),
					timerPos = document.getElementsByClassName( 'timer' )[ 0 ].getBoundingClientRect().left - handleMid.left,
					AppState = App.state;

				// VIDEO HAS REACHED OF THE CURRENT LOOP, RESET TO START POSITION
				if ( ( video.currentTime >= Number( AppState.videoEndTime ) ) 	// OVER SET END TIME
					|| ( video.currentTime >= video.duration )				// OVER VIDEO TOTAL TIME
					|| timerPos >= handleMid.width ) {   								// SURPASSED BOUNDING REGION OF HANDLE

					// PREVENT SAVING VIDEO FRAMES TO AVOID DUPLICATES
					if ( AppState.saveFrames )
						App.setState( prevState => ({ saveFrames: false }) );

					// SET THE TIME BACK TO BEGINNING OF SELECTED RANGE
					if ( video.duration ) video.currentTime = AppState.videoStartTime || 0;

					$this.setTimer( { reset: true } )
				}

				// SET INITIAL ANIMATION TO END OF HANDLE
				if ( setTimer && $this.getPositionInTime( handleMid.width ) ) {

					$this.setTimer( { custom: 15 } );

					setTimer = false;
				}

				// CALL UPDATE CURRENT AT NEXT AVAILABLE CHANCE
				requestAnimationFrame( updateCurrentTime );
			};

			requestAnimationFrame( updateCurrentTime );
		}
	}


	// SIMILAR TO DURATION CHANGE BUT INSTEAD FOR THE PREVIEW IMAGES ON THE TRACK
	// =============================================================================================
	previewLoaded( options ) {

		let stream = document.getElementById( 'stream-preview' );

		if ( !stream ) return false;

		let $this = this,
			nVH = 60,
			aspectRatio = nVH / options.video.videoHeight,
			nVW = options.video.videoWidth * aspectRatio,
			numberOfPreviewImages = ( stream.offsetWidth / nVW ).toFixed(),
			p1 = numberOfPreviewImages && options.video.duration ? options.video.duration / numberOfPreviewImages : 0;

		options.canvas.width = nVW;
		options.canvas.height = nVH;

		this.drawImageToCanvas( options.canvas, options.context, options.video, options.canvas.width, options.canvas.height );


		// GET BLOB AND ADD TO SEEK PREVIEW IMAGES
		// -----------------------------------------------------------------------------------------
		options.canvas.toBlob( function ( blob ) {

			// EXIT IF NO DATA
			if ( !blob ) return false;

			// SETUP NEW IMAGE ELEMENT
			let url = URL.createObjectURL( blob ),
				img = document.createElement( 'img' ),
				video = options.video;

			// FREE UP OBJECT URL ONCE IMAGE IS LOADED
			img.onLoad = function () {

				URL.revokeObjectURL( url );
			};

			// SET IMAGE SRC
			img.src = url;

			// ADD IMAGE TO DOM
			stream.appendChild( img );

			// ADD TO PREVIEW IMAGE ARRAY
			$this.previewImages.push( url );

			// INCREMENT TIME ON PREVIEW VIDEO STREAM
			video.currentTime += p1;

			// SET UP LISTENER IF IT DOESN'T ALREADY EXIST
			if ( !$this.previewVideoListener )
				video.addEventListener( 'seeked', function () {

					// PREVENT LISTENERS
					$this.previewVideoListener = true;

					if ( $this.previewImages.length < numberOfPreviewImages ) $this.previewLoaded( options );

					else video.removeEventListener( 'seeked', this );
				} );
		}, 'image/jpeg', 0.8 );
	}


	// drawCanvas LOOP TO PAINT A VIDEO FRAME TO THE CANVAS
	// =============================================================================================
	drawCanvas() {
		let video = this.video,
			canvas = this.state.canvas,
			context = this.state.context,
			saveNewFrame = this.props.App.state.saveFrames,
			FPSInterval = this.state.interval;

		if ( video && !video.seeking ) {

			// SET DIMENSIONS
			this.setDimensions();

			this.drawImageToCanvas( canvas, context, video, canvas.width, canvas.height );

			// STORE NEW IMAGE TO ARRAY
			if ( saveNewFrame ) this.storeNewImage();
		}

		// THIS SHOULD BE OK FOR NOW BUT WE MIGHT WANT TO CONSIDER AN FPS CONTROLLER THAT
		// USES requestAnimationFrame() IN A LOOP DETERMINED BY INTERVAL
		setTimeout( this.drawCanvas.bind( this ), FPSInterval );
	}


	// FUNCTION THAT CHECKS FOR BROWSER AND FORMAT EXCEPTIONS AND DRAWS THE IMAGE TO CANVAS
	// =============================================================================================
	drawImageToCanvas( canvas, context, video, width, height ) {
		let AppState = this.props.App.state,
			needsOrientation = this.state.imageNeedsOrientation;

		// DRAWS CURRENT VIDEO FRAME TO CANVAS
		if ( needsOrientation && AppState.orientationMatrix && AppState.orientationMatrix.length ) {


			// EXTRACT ROTATION INFORMATION FROM MATRIX
			// -------------------------------------------------------------------------------------
			let rotation = 0;

			AppState.orientationMatrix.forEach( function( matrix ) {

				if ( matrix[0][0] && matrix[1][1] ) rotation = 180;

				else if ( matrix[0][1] ) rotation = -90;

				else if ( matrix[1][0] ) rotation = 90;
			});


			// SET ROTATION AND DRAW IMAGE
			// -------------------------------------------------------------------------------------
			switch( rotation ) {
				default :
				case 0:
					canvas.setAttribute( 'width', width );
					canvas.setAttribute( 'height', height );
					context.drawImage( video, 0, 0, width, height );
					break;

				case 90:
					canvas.setAttribute( 'width', width );
					canvas.setAttribute( 'height', height );
					context.rotate( 90 * Math.PI / 180 );

					// DRAW IMAGE TO CANVAS - HEIGTH IS NEGATIVE WIDTH BECAUSE OF TRANSFORM
					if ( navigator.userAgent.indexOf("Firefox") > -1 )
						context.drawImage( video, 0, -width, height, width );

					// FIREFOX AND IOS NEED TO BE HANDLED SLIGHTLY DIFFERENTLY
					else this.drawImageIOSFix( context, video, 0, -width, height, width );

					break;

				case 180:
					canvas.setAttribute( 'width', width );
					canvas.setAttribute( 'height', height );
					context.rotate( 180 * Math.PI / 180 );
					context.drawImage( video, -width, -height, width, height );
					break;

				case 270:
				case -90:
					canvas.setAttribute( 'width', width );
					canvas.setAttribute( 'height', height );
					context.rotate( 270 * Math.PI / 180 );

					// DRAW IMAGE TO CANVAS - HEIGTH IS NEGATIVE WIDTH BECAUSE OF TRANSFORM
					if ( navigator.userAgent.indexOf("Firefox") > -1 )
						context.drawImage( video, -height, 0, height, width );

					// FIREFOX AND IOS NEED TO BE HANDLED SLIGHTLY DIFFERENTLY
					else this.drawImageIOSFix( context, video, -height, 0, height, width );
					break;
			}

		} else context.drawImage( video, 0, 0, width, height );
	}


	// SET DIMENSIONS OF CANVAS ELEMENT BASED ON VIDEO ELEMENTS RATIO AND maxGifDimensions
	// =============================================================================================
	setDimensions( width, height ) {
		let App = this.props.App,
			state = this.state,
			canvas = state.canvas,
			videoWidth = this.video.videoWidth,
			videoHeight = this.video.videoHeight,
			selectedWidth = width || App.state.canvasWidth,
			selectedHeight = height || App.state.canvasHeight;


		// CONTINUE ONLY IF THERE HAS BEEN A CHANGE
		// -----------------------------------------------------------------------------------------
		if ( !videoWidth || App.state.canvasWidth !== canvas.width || App.state.canvasHeight !== canvas.height ) {


			// IMAGE QUALITY IS ONE OF THE PRESETS AND AND THE IMAGE WON'T BE LARGER THAN THE ORIGINAL
			// -------------------------------------------------------------------------------------
			if ( App.state.imageQuality !== 'advanced' ) {
				let ratio = videoHeight / videoWidth;

				canvas.width = selectedWidth;
				canvas.height = selectedWidth * ratio;


			// MAINTAIN ASPECT RATIO IF CHECKED
			// -------------------------------------------------------------------------------------
			} else if ( state.forceAspectRatio ) {
				let gifWidth = selectedWidth || videoWidth,
					gifHeight = selectedHeight || videoHeight,
					ratio = videoHeight / videoWidth;

				// TODO: FIND SOLUTION FOR THIS BROKEN IF STATEMENT CHECK
				if ( App.state.axis === 'x' ) {
					canvas.width = gifWidth;
					canvas.height = gifWidth * ratio;

				} else {
					canvas.width = gifHeight / ratio;
					canvas.height = gifHeight;
				}


			// ALLOW FOR WHATEVER AS LONG AS NOT IN ABOVE
			// -------------------------------------------------------------------------------------
			} else {

				canvas.width = selectedWidth;
				canvas.height = selectedHeight;
			}


			// UPDATE STATE
			// -------------------------------------------------------------------------------------
			App.setState( prevState => ({
				canvasWidth: canvas.width,
				canvasHeight: canvas.height
			}) );
		}
	}


	// ADDS A NEW IMAGE TO THE IMAGE ARRAY WHICH IS EVENTUALLY SENT TO this.props.App.generateGif()
	// =============================================================================================
	storeNewImage() {
		let canvas = this.state.canvas,
			context = this.state.context;

		// GETIMAGEDATA WILL ERROR OUT IF W/H IS 0
		if ( canvas.width < 1 || canvas.height < 1 ) return;

		this.encoderWorker.postMessage({ image: context.getImageData( 0, 0, canvas.width, canvas.height ) });
	}


	// FIRED BY EDITING THE PLAY LOOP RANGE USING THE HANDLES
	// =============================================================================================
	handleDragged( e ) {
		let $this = this,
			App = this.props.App,
			element = e.target,
			handleMiddle = document.getElementsByClassName( 'handle-mid' )[ 0 ],
			handleContainer = handleMiddle.parentNode,
			stream = handleContainer.parentNode,
			maxWidth = Math.floor( this.state.maxHandleWidth || stream.offsetWidth ),
			bounding = e.target.dataset.side,
			mouseX = e.clientX || e.targetTouches[ 0 ].clientX,
			previousIncrement;

		this.setState( prevState => ({ hideTimer: true }) );

		// PREVENT ANY CHILD ELEMENTS FROM FIRING EVENT
		e.stopPropagation();

		// SET THE STARTING POSITION AS THE BOUNDING REGIONS LEFT POSITION ON PAGE TODO: THIS LOOKS WRONG
		let start = ( bounding === 'middle' ? handleContainer.offsetLeft : element.getBoundingClientRect().left );


		// ADD EVENT LISTENER FOR DRAGGING MAIN HANDLE, ON BODY SO WE DON'T HAVE TO STAY OVER HANDLE
		// -----------------------------------------------------------------------------------------
		let moveHandler = function ( e ) {
			e = e || window.event;

			// STOP TEXT HIGHLIGHTING
			e.preventDefault();

			// EDIT THE ELEMENTS POSITION
			let clientX = e.clientX || e.targetTouches[ 0 ].clientX,
				position = start + clientX - mouseX,
				handleMiddleWidth = handleMiddle.offsetWidth,
				handleMiddlePosition = handleMiddle.parentNode.offsetLeft + 15;


			// DON'T ALLOW POSITION TO MOVE OUTSIDE CLIENT REGION
			// -------------------------------------------------------------------------------------
			if ( bounding === 'middle' ) {

				// PREVENT MOVING OFF LEFT OF CONTAINER
				if ( position < -15 ) position = -15;

				// PREVENT MOVING OFF RIGHT OF CONTAINER
				else if ( ( position + handleContainer.offsetWidth ) > stream.offsetWidth + 15 )
					position = Math.abs( stream.offsetWidth - ( handleContainer.offsetWidth ) + 15 );

				// UPDATE CONTAINER POSITION IN DOM
				handleContainer.style.left = position + "px";

				App.setState( prevState => ({
					videoStartTime: $this.video.currentTime = $this.getPositionInTime( handleMiddlePosition ),
				}) )


			// RIGHT HANDLE
			// -------------------------------------------------------------------------------------
			} else if ( bounding === 'right' ) {

				position -= Math.floor( handleContainer.getBoundingClientRect().left - 15 );

				// PREVENT RIGHT HANDLE MOVING BEFORE LEFT HANDLE
				if ( position < 30 ) position = 30;

				// PREVENT MOVING OFF RIGHT OF OUTER CONTAINER
				else if ( ( ( handleContainer.offsetLeft ) + position ) > stream.offsetWidth + 15 ) return;

				// IF THE POSITION OF THE ELEMENT IS GREATER THAN THE MAX WIDTH, RETURN
				if ( maxWidth && ( position - 30 > maxWidth ) ) return;

				// UPDATE THE WIDTH OF CONTAINER
				handleContainer.style.width = Math.floor( position ) + 'px';

				// UPDATE RIGHT HANDLES POSITION
				position = Math.floor( position - handleContainer.offsetWidth );

				// UPDATE CONTAINERS POSITION
				element.style.left = position + "px";

				App.setState( prevState => ({
					videoStartTime: $this.video.currentTime = $this.getPositionInTime( handleMiddlePosition + handleMiddleWidth ),
				}), () => {

					$this.setState( prevState => ({
						leftTime: $this.getPositionInTime( handleMiddlePosition + handleMiddleWidth ),
						rightTime: false,
						tooltip: $this.getPositionInTime( handleMiddleWidth ).toFixed( 1 )
					}) );
				})


			// LEFT HANDLE
			// -------------------------------------------------------------------------------------
			} else if ( bounding === 'left' ) {

				position -= Math.floor( stream.getBoundingClientRect().left - 30 );

				// PREVENT LEFT HANDLE MOVING OFF LEFT OUTER CONTAINER
				if ( clientX < ( stream.offsetLeft - 15 ) ) handleContainer.style.left = -15 + 'px';

				// PREVENT LEFT HANDLE MOVING OFF RIGHT SIDE OF OUTER CONTAINER
				else if ( ( position + 15 ) > ( stream.offsetWidth + 30 ) ) return;

				// PREVENT LEFT HANDLE PASSING OVER RIGHT HANDLE ]
				else if ( ( handleContainer.offsetWidth < 30 ) ) handleContainer.style.width = 30 + 'px';

				// SET CONTAINERS WIDTH TO IT'S WIDTH PLUS THE NUMBER OF PIXES IN CHANGE
				else {

					// UPDATE THE CONTAINERS POSITION TO THE CLIENTS X CO ORDINATE MINUS IT'S PARENTS LEFT VALUE
					handleContainer.style.left = position - 30 + 'px';

					// SET CONTAINERS WIDTH TO IT'S WIDTH PLUS THE NUMBER OF PIXES IN CHANGE
					handleContainer.style.width = handleContainer.offsetWidth + ( -( previousIncrement ? position - previousIncrement : 1  ) ) + 'px';

					// REPLACE PREVIOUS INCREMENT
					previousIncrement = position;
				}

				App.setState( prevState => ({
					videoStartTime: $this.video.currentTime = $this.getPositionInTime( handleMiddlePosition ),
				}), () => {

					// SET VIDEO ELEMENTS CURRENT TIME AND START TIME
					$this.setState( prevState => ({
						leftTime: false,
						rightTime: $this.getPositionInTime( handleMiddlePosition ),
						tooltip: $this.getPositionInTime( handleMiddleWidth ).toFixed( 1 )
					}) );
				});

			} else {

				// SET VIDEO ELEMENTS CURRENT TIME AND START TIME
				App.setState( prevState => ({
					videoStartTime: $this.video.currentTime = $this.getPositionInTime( handleMiddlePosition )
				}) );
			}
		};

		// ADD MOVE EVENTS
		document.body.addEventListener( 'mousemove', moveHandler );
		document.body.addEventListener( 'touchmove', moveHandler );


		// CANCEL EVENTS AFTER MOUSE RELEASED
		// -----------------------------------------------------------------------------------------
		let upHandler = function () {

			if ( $this.video ) {
				let handleMiddleWidth = handleMiddle.offsetWidth,
					handleMiddlePosition = handleMiddle.parentNode.offsetLeft + 15;

				// SET VIDEO ELEMENTS CURRENT TIME AND START TIME
				$this.video.currentTime = $this.getPositionInTime( handleMiddlePosition );

				// WE NEED TO RESET THESE SO WE DON'T ADD IMAGES NOT YET PROCESSED TO A NEW IMAGES ARRAY
				$this.receivedMessageCount = 0;

				// START SAVING VIDEO FRAMES TO IMAGE ARRAY
				$this.props.App.setState( prevState => ({
					gifDuration: Number( $this.getPositionInTime( handleMiddleWidth ).toFixed( 1 ) ),
					saveFrames: true,
					videoStartTime: $this.getPositionInTime( handleMiddlePosition ),
					videoEndTime: $this.getPositionInTime( handleMiddlePosition + handleMiddleWidth ),
					tooltipInSeconds: $this.getPositionInTime( handleMiddleWidth ).toFixed( 1 ),
					images: []
				}), () => {

					$this.setState( prevState => ({
						hideTimer: false,
						leftTime: false,
						rightTime: false,
						tooltip: $this.getPositionInTime( handleMiddleWidth ).toFixed( 1 )
					}) );
				});

				window.mixpanel.track( 'Edit-video', {
					app: 'video-to-gif',
					action: 'time-range-changed',
					duration: Number( $this.getPositionInTime( handleMiddleWidth ).toFixed( 1 ) )
				} );

				$this.setTimer( { reset: true } );
			}

			// REMOVE ALL LISTENERS
			document.body.removeEventListener( 'mousemove', moveHandler );
			document.body.removeEventListener( 'touchmove', moveHandler );
			document.body.removeEventListener( 'mouseup', upHandler );
			document.body.removeEventListener( 'touchend', upHandler );
		};

		// ADD CLICK/TOUCH END EVENTS
		document.body.addEventListener( 'mouseup', upHandler );
		document.body.addEventListener( 'touchend', upHandler );
	}


	// GIVES THE POSITION IN THE STREAM BY PASSING IN A PIXEL VALUE AND RETURNING SECONDS
	// =============================================================================================
	getPositionInTime( position ) {
		let stream = document.getElementById( 'stream' ),
			streamWidth = stream.offsetWidth,
			duration = this.video.duration;

		return duration / ( 100 / ( position / streamWidth * 100 ) );
	}


	// SETS THE POSITION OF THE TIME INDICATOR BAR MOVING ACCROSS THE STREAM
	// =============================================================================================
	setTimer( options ) {
		let timeIndicatorStyles = document.getElementsByClassName( 'timer' )[ 0 ].style,
			handleMiddle = document.getElementsByClassName( 'handle-mid' )[ 0 ],
			handleMiddleWidth = handleMiddle.offsetWidth,
			handleMiddlePosition = handleMiddle.parentNode.offsetLeft + 17;

		// RESET TIMER POSITION TO START OF HANDLE
		if ( options && options.reset ) {
			timeIndicatorStyles.transition = 'all linear 0s';
			timeIndicatorStyles.transform = 'translateX(' + handleMiddlePosition + 'px)';
		}

		// ANIMATE HANDLE TO END OF HANDLE
		timeIndicatorStyles.transition = 'all linear ' + this.getPositionInTime( handleMiddleWidth + 15 ) + 's';
		timeIndicatorStyles.transform = 'translateX(' + ( handleMiddleWidth + handleMiddlePosition + ( ( options && options.custom ) || 0 ) ) + 'px)';
	}


	// SETS THE RESULTING GIF QUALITY TO HIGH MEDIUM OR LOW
	// =============================================================================================
	selectQuality( e ) {
		let AppState = this.props.App.state, selectedQuality,
			quantizationLevel,
			fps, width, height;

		// FIND OUT IF FROM EVENT OR CALLED MANUALLY
		if ( e && e.target ) {
			e.preventDefault();

			selectedQuality = e.target.dataset.level;

		} else selectedQuality = AppState.imageQuality;

		window.mixpanel.track( 'Edit-video', {
			app: 'video-to-gif',
			action: 'selected-quality',
			quality: selectedQuality
		});


		// SET QUALITY PARAMS
		// -----------------------------------------------------------------------------------------
		switch ( selectedQuality ) {

			case 'high':
				fps = 20;
				quantizationLevel = 1;
				width = 400;
				break;
			case 'medium':
			default:
				fps = 12;
				quantizationLevel = 10;
				width = 325;
				break;
			case 'low':
				fps = 9;
				quantizationLevel = 20;
				width = 250;
				break;
			case 'advanced':
				fps = AppState.customFrameRate || 10;
				quantizationLevel = 20;
				width = AppState.canvasWidth || 0;
				height = AppState.canvasHeight || 0;
				break;
		}


		// WE NEED TO RESET THESE SO WE DON'T ADD IMAGES NOT YET PROCESSED TO A NEW IMAGES ARRAY
		this.receivedMessageCount = 0;


		// SET PARAMS TO STATE
		// -----------------------------------------------------------------------------------------
		this.setState( prevState => ({
			interval: 1000 / fps
		}) );

		this.props.App.setState( prevState => ({
			frameRate: fps,
			saveFrames: true,
			canvasWidth: width,
			canvasHeight: height,
			sampleInterval: quantizationLevel,
			imageQuality: selectedQuality,
			images: []
		}) );

		// SET CURRENT TIME BACK TO START
		this.video.currentTime = AppState.videoStartTime || 0;

		this.setTimer( { reset: true } );
	}


	// FIX FOR iOS DRAW IMAGE SHAMELESSLY TAKEN FROM STACK OVERFLOW
	// https://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
	// =============================================================================================
	drawImageIOSFix( ctx, video, dx, dy, dw, dh ) {

		// DETECTING VERTICAL SCALING IN iOS IMAGE
		function detectVerticalSquash( video ) {
			let ih = video.videoHeight,
				canvas = document.createElement( 'canvas' );

			canvas.width = 1;
			canvas.height = ih;

			let ctx = canvas.getContext( '2d', { alpha: false } );

			ctx.drawImage(video, 0, 0);

			let data = ctx.getImageData( 0, 0, 1, ih ).data,
				sy = 0,
				ey = ih,
				py = ih;

			while ( py > sy ) {
				let alpha = data[ ( py - 1 ) * 4 + 3 ];

				if ( alpha === 0 ) ey = py;

				else sy = py;

				py = ( ey + sy ) >> 1;
			}

			let ratio = ( py / ih );

			return ( ratio === 0 ) ? 1 : ratio;
		}

		let vertSquashRatio = detectVerticalSquash( video );

		ctx.drawImage( video, dx, dy, dw, dh / vertSquashRatio );
	}
}

export default VideoComponent;



// WEBPACK FOOTER //
// ./src/app/scenes/video.js